import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    Grid,
    IconButton,
    makeStyles,
    MenuItem,
    Slide,
    Typography,
    useMediaQuery,
    useTheme,
} from '@material-ui/core';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import CloseIcon from '@material-ui/icons/Close';
import { Marker, Circle, Tooltip, useMap } from 'react-leaflet';
import Map from '../Map';
import * as L from 'leaflet';
import { CustomTextField } from '../Textfield';
import { PlaceAutoComplete } from '../UI';
import { Spinner } from '../UI';
import {
    CreateHub,
    EditHub,
    GetBusinessList,
    GetchZones,
    GetCities,
    GetCityZones,
} from '../../store/actions/settingsActionCreator';
import { connect } from 'react-redux';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { HUB_TYPE_ENUM } from '../../utils/constants';
import { Autocomplete } from '@material-ui/lab';
import CustomSwitch from '../Switch';
const useStyles = makeStyles((theme) => ({
    modal: {
        '& .modal-head': {
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'space-between',
        },
        '& .modal-title': {
            fontSize: '24px',
            fontWeight: 'bold',
            color: '#14112d',
        },
        '& .modal-subtitle': {
            fontSize: '14px',
            fontWeight: 'normal',
            color: '#14112d',
        },

        '& .cancelButton': {
            color: theme.palette.text.primary,
        },
        '& .leaflet-container': {
            width: '100%',
            minHeight: '600px',
            // height: '630px',
            // borderRadius: 16,
            borderTopRightRadius: 16,
            borderBottomRightRadius: 16,
        },
        // '& .xutil': {
        //     '& .leaflet-container': {
        //         width: '100%',
        //         // borderRadius: 16,
        //         borderTopRightRadius: 16,
        //         borderBottomRightRadius: 16,
        //     },
        // },
        '& [data-color="food"]': {
            '& .MuiOutlinedInput-input': {
                color: '#ec4e2b',
                fontWeight: 'bold',
            },
        },
        '& [data-color="ecom"]': {
            '& .MuiOutlinedInput-input': {
                color: '#43419e',
                fontWeight: 'bold',
            },
        },
        '& [data-color="store"]': {
            '& .MuiOutlinedInput-input': {
                color: '#579b5a',
                fontWeight: 'bold',
            },
        },
    },
    iconButton: {
        padding: '0px',
    },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const myIcon = L.icon({
    iconUrl:
        'http://www.pngall.com/wp-content/uploads/2017/05/Map-Marker-PNG-File.png',
    iconSize: [40, 40],
    iconAnchor: [32, 64],
    popupAnchor: null,
    shadowUrl: null,
    shadowSize: null,
    shadowAnchor: null,
});

const PlatformTypes = [
    { label: 'On Platform', value: true },
    { label: 'Off Platform', value: false },
];

function HubModal({
    currentOrgId,
    orgCustomerMappings,
    isEnabledXUtil,
    open,
    onClose,
    maxWidth,
    defaultValue = {},
    settings,
    statesList,
    cityList,
    zonesList,
    dispatchCreateHub,
    dispatchEditHub,
    dispatchGetCities,
    dispatchGetCityZones,
    dispatchGetchZones,
    dispatchGetBusinessList,
    ...props
}) {
    const classes = useStyles();
    const theme = useTheme();
    const placeAutoCompleteRef = useRef(null);
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const [isOpen, toggleModal] = useState(open);
    const [loading, toggleLoading] = useState(false);
    const [address, setAddress] = useState({});
    const [selectedOrgCustomer, setSelectedOrgCustomer] = useState({});
    const markerRef = useRef(null);
    const [mapview] = useState({
        lat: 21.7679,
        lng: 78.8718,
    });
    const [position, setPosition] = useState();
    const eventHandlers = useMemo(
        () => ({
            dragend() {
                const marker = markerRef.current;
                if (marker != null) {
                    console.log(marker.getLatLng());
                    setPosition(marker.getLatLng());
                }
            },
        }),
        [],
    );

    const fetchAddressFromLatLng = async (latLng) => {
        fetch(
            `https://nominatim.openstreetmap.org/reverse?lat=${latLng?.latitude}&lon=${latLng?.longitude}&format=json`,
            // `https://maps.googleapis.com/maps/api/geocode/json?latlng=${location?.coords?.latitude},${location?.coords?.longitude}&key=${GOOGLE_MAP_API_KEY}`,
        )
            .then((response) => response.json())
            .then((data) => {
                console.log('fetchCityName', data);
                setPosition({
                    lat: latLng?.latitude,
                    lng: latLng?.longitude,
                });
                formik.setFieldValue('address', data?.display_name, true);
                setAddress({
                    address: data?.display_name,
                    latLng: {
                        lat: latLng?.latitude,
                        lng: latLng?.longitude,
                    },
                });

                // Update the PlaceAutoComplete component's internal state
                if (placeAutoCompleteRef?.current) {
                    placeAutoCompleteRef.current.handleChange({
                        address: data?.display_name,
                    });
                }
            })
            .catch((error) => {});
    };

    const formik = useFormik({
        initialValues: {
            name: '',
            ...(isEnabledXUtil
                ? { primaryOperation: HUB_TYPE_ENUM.FOOD.value }
                : {}),
            address: '',
            cityName: settings?.basicDetails?.cityName,
            stateName: settings?.basicDetails?.stateName,
            geofenceRadius: '',
            zoneId: '',
            orderOnPlatform: '',
            orgCustomerId: null,
            ...defaultValue,
            latitude: defaultValue?.latitude
                ? Number(defaultValue.latitude)
                : undefined,
            longitude: defaultValue?.longitude
                ? Number(defaultValue.longitude)
                : undefined,
            dedicatedSlotBookingEnabled:
                defaultValue?.dedicatedSlotBookingEnabled ?? false,
            referralProgram:  
                defaultValue?.referralProgram ?? false,  
            referralAmount:  
                defaultValue?.referralAmount ?? null,
        },
        validationSchema: yup.object({
            name: yup.string('Name is invalid').required('Name is required'),
            ...(isEnabledXUtil
                ? {
                      primaryOperation: yup
                          .string('Primary Operation is invalid')
                          .nullable(true)
                          .required('Primary Operation is required'),
                      orgCustomerId: yup
                          .number('Please select a valid business')
                          .transform((value) =>
                              isNaN(value) ? undefined : value,
                          )
                          .nullable(true)
                          .when('primaryOperation', {
                              is: (primaryOperation) =>
                                  primaryOperation !== HUB_TYPE_ENUM.ECOM.value,
                              then: yup
                                  .number('Please select a valid business')
                                  .required('Business is required')
                                  .typeError('Please select a valid business'),
                          }),
                      orderOnPlatform: yup
                          .string('Platform Type is invalid')
                          .required('Platform Type is required'),
                  }
                : {}),
            cityName: yup
                .string('City is invalid')
                .required('City is required'),
            stateName: yup
                .string('state is invalid')
                .required('state is required'),
            zoneId: yup
                .string()
                .nullable()
                .when(['primaryOperation'], {
                    is: (primaryOperation) => {
                        const isEcom =
                            primaryOperation === HUB_TYPE_ENUM.ECOM.value;
                        const isFood =
                            primaryOperation === HUB_TYPE_ENUM.FOOD.value;
                        return isEcom || isFood;
                    },
                    then: yup
                        .string('Zone is invalid')
                        .required('Zone is required'),
                }),
            address: yup.string().when('primaryOperation', {
                is: (primaryOperation) =>
                    primaryOperation !== HUB_TYPE_ENUM.FOOD.value,
                then: yup
                    .string('Address is invalid')
                    .when(['latitude', 'longitude'], {
                        is: (latitude, longitude) => !latitude || !longitude,
                        then: yup
                            .string()
                            .required(
                                'Please Enter Either address or coordinates are required',
                            ),
                    }),
            }),
            latitude: yup
                .number('Latitude is invalid')
                .when(['address', 'primaryOperation'], {
                    is: (address, primaryOperation) =>
                        !address &&
                        primaryOperation !== HUB_TYPE_ENUM.FOOD.value,
                    then: yup
                        .number()
                        .typeError('Invalid longitude format')
                        .required(
                            'Please Enter Either address or coordinates are required',
                        ),
                }),
            longitude: yup
                .number('Longitude is invalid')
                .when(['address', 'primaryOperation'], {
                    is: (address, primaryOperation) =>
                        !address &&
                        primaryOperation !== HUB_TYPE_ENUM.FOOD.value,
                    then: yup
                        .number()
                        .typeError('Invalid longitude format')
                        .required(
                            'Please Enter Either address or coordinates are required',
                        ),
                }),
            geofenceRadius: yup
                .number()
                .nullable()
                .when('primaryOperation', {
                    is: (primaryOperation) =>
                        primaryOperation !== HUB_TYPE_ENUM.FOOD.value,
                    then: yup
                        .number('geofenceRadius is invalid')
                        .required('geofenceRadius is required'),
                }),
                referralAmount: yup  
                .number()  
                .nullable()  
                .when('referralProgram', {  
                    is: true,  
                    then: yup  
                        .number('Referral Amount is invalid')  
                        .required('Referral Amount is required')  
                        .positive('Referral Amount must be greater than 0')  
                        .typeError('Please enter a valid number'),  
                }),
        }),
        onSubmit: async (values) => {
            await toggleLoading(true);
            const payload = {
                ...values,
                latitude: address?.latLng?.lat,
                longitude: address?.latLng?.lng,
            };
            if (Object.keys(defaultValue)?.length) {
                dispatchEditHub(
                    {
                        hubs: [
                            {
                                ...payload,
                            },
                        ],
                    },
                    async (resp) => {
                        await toggleLoading(false);
                        handleClose();
                    },
                    async (resp) => {
                        await toggleLoading(false);
                        handleClose();
                    },
                );
            } else {
                dispatchCreateHub(
                    {
                        hubs: [
                            {
                                ...payload,
                                organizationId: settings?.basicDetails?.id,
                                isActive: true,
                            },
                        ],
                    },
                    async (resp) => {
                        await toggleLoading(false);
                        handleClose();
                    },
                    async (resp) => {
                        await toggleLoading(false);
                        handleClose();
                    },
                );
            }
        },
    });

    useEffect(() => {
        // fetchCities();
        fetchCityZones({
            cityId: settings?.basicDetails?.operatingCityId,
            hubIds: !!defaultValue?.id ? [defaultValue?.id] : null,
            primaryOperation: isEnabledXUtil
                ? [HUB_TYPE_ENUM.FOOD.value]
                : null,
        });
        fetchBusinessList(
            defaultValue?.primaryOperation || HUB_TYPE_ENUM.FOOD.value,
        );
        if (Object.keys(defaultValue)?.length) {
            formik.setFieldValue('address', defaultValue.address);
            if (!!defaultValue?.orgCustomerId) {
                setSelectedOrgCustomer(
                    orgCustomerMappings?.find(
                        (org) => org?.id === defaultValue?.orgCustomerId,
                    ),
                );
            }
            if (
                defaultValue.address &&
                defaultValue.latitude &&
                defaultValue.longitude
            ) {
                setAddress({
                    address: defaultValue.address,
                    latLng: {
                        lat: defaultValue.latitude,
                        lng: defaultValue.longitude,
                    },
                });
                setPosition({
                    lat: defaultValue.latitude,
                    lng: defaultValue.longitude,
                });
            }
        }

        return () => {
            toggleLoading(false);
        };
    }, []);

    useEffect(() => {
        if (!!formik.values.latitude && !!formik.values?.longitude) {
            fetchAddressFromLatLng({
                latitude: formik.values.latitude,
                longitude: formik.values?.longitude,
            });
        }
    }, [formik.values.longitude, formik.values?.latitude]);

    const fetchCityZones = async (payload) => {
        if (!settings?.basicDetails?.operatingCityId) return 0;
        await toggleLoading(true);
        dispatchGetchZones(
            payload,
            (resp) => {
                toggleLoading(false);
            },
            (err) => {
                toggleLoading(false);
            },
        );
    };
    const fetchCities = async () => {
        await toggleLoading(true);
        dispatchGetCities(
            {},
            (resp) => {
                toggleLoading(false);
            },
            (err) => {
                toggleLoading(false);
            },
        );
    };

    const handleClose = () => {
        toggleModal(!isOpen);
        onClose && onClose();
    };

    const fetchBusinessList = (primaryOperation) => {
        dispatchGetBusinessList(
            currentOrgId,
            { primaryOperation },
            () => {},
            (err) => {
                console.log('dispatchGetBusinessList error', err);
            },
        );
    };

    const getBounds = () => {
        return position
            ? [
                  [position.lat, position.lng],
                  [position.lat, position.lng],
              ]
            : [
                  [mapview.lat, mapview.lng],
                  [mapview.lat, mapview.lng],
              ];
    };

    const actions = [
        <Button
            key={1}
            variant="contained"
            color="default"
            className={`cancelButton`}
            onClick={handleClose}
            disableElevation
        >
            {'Cancel'}
        </Button>,
        <Button
            key={2}
            variant="contained"
            color="primary"
            className={`saveButton`}
            type="submit"
            disableElevation
        >
            {Object.keys(defaultValue)?.length ? 'Update Hub' : 'Add Hub'}
        </Button>,
    ];

    // function MapEvents() {
    //     const map = useMapEvents({
    //         click: () => {
    //             map.locate();
    //         },
    //         locationfound: (e) => {
    //             console.log('map', map);
    //             console.log('location found:', e);
    //             setPosition({ lat: e.latitude, lng: e.longitude });
    //             map.flyTo({ lat: e.latitude, lng: e.longitude }, map.getZoom());
    //         },
    //     });
    //     return null;
    // }

    console.log('formik', formik.errors);

    return (
        <Dialog
            open={isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={handleClose}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
            className={classes.modal}
            fullScreen={fullScreen}
            fullWidth={true}
            maxWidth={maxWidth ?? 'md'}
        >
            <Spinner loading={loading}>
                <form
                    onSubmit={formik.handleSubmit}
                    className={isEnabledXUtil ? 'xutil' : ''}
                >
                    <Grid container>
                        <Grid item xs={6}>
                            <DialogTitle id="alert-dialog-slide-title">
                                <Box className={`modal-head`}>
                                    <div>
                                        <Typography
                                            className={`modal-title`}
                                            variant="h6"
                                        >
                                            {Object.keys(defaultValue)?.length
                                                ? 'Edit Hub'
                                                : 'Add Hub'}
                                        </Typography>
                                        <Typography
                                            className={`modal-subtitle`}
                                            variant="body2"
                                        >
                                            {Object.keys(defaultValue)?.length
                                                ? 'Edit hub of your team list.'
                                                : 'Add New hub to your team list.'}
                                        </Typography>
                                    </div>
                                    <div
                                        style={{
                                            alignSelf: 'center',
                                            justifySelf: 'flex-end',
                                        }}
                                    >
                                        <IconButton
                                            aria-label="delete"
                                            className={classes.iconButton}
                                            onClick={handleClose}
                                        >
                                            <CloseIcon />
                                        </IconButton>
                                    </div>
                                </Box>
                            </DialogTitle>
                            {!!isEnabledXUtil ? (
                                <DialogContent
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        flexWrap: 'wrap',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                        marginBottom: '60px',
                                    }}
                                >
                                    <CustomTextField
                                        fullWidth={true}
                                        label="Name"
                                        variant="outlined"
                                        style={{
                                            marginBottom: '16px',
                                        }}
                                        id="name"
                                        name="name"
                                        value={formik.values.name}
                                        onChange={formik.handleChange}
                                        error={
                                            formik.touched.name
                                                ? Boolean(formik.errors.name)
                                                : false
                                        }
                                        helperText={
                                            formik.touched.name &&
                                            formik.errors.name
                                        }
                                        isRequired={true}
                                    />
                                    <CustomTextField
                                        label="Platform Type"
                                        select
                                        style={{
                                            marginBottom: '16px',
                                            width: '48%',
                                        }}
                                        id="orderOnPlatform"
                                        name="orderOnPlatform"
                                        value={formik.values.orderOnPlatform}
                                        onChange={formik.handleChange}
                                        error={
                                            formik.touched.orderOnPlatform
                                                ? Boolean(
                                                      formik.errors
                                                          .orderOnPlatform,
                                                  )
                                                : false
                                        }
                                        helperText={
                                            formik.touched.orderOnPlatform &&
                                            formik.errors.orderOnPlatform
                                        }
                                        isRequired={true}
                                    >
                                        {PlatformTypes.map((pt) => {
                                            return (
                                                <MenuItem value={pt.value}>
                                                    {pt.label}
                                                </MenuItem>
                                            );
                                        })}
                                    </CustomTextField>
                                    <Autocomplete
                                        multiple={false}
                                        options={[
                                            ...Object.keys(
                                                HUB_TYPE_ENUM,
                                            ).filter((i) => !!i),
                                        ]}
                                        getOptionLabel={(option) => {
                                            return HUB_TYPE_ENUM?.[option]
                                                ?.label;
                                        }}
                                        onChange={(event, newValue) => {
                                            formik.setFieldValue(
                                                'primaryOperation',
                                                newValue ?? '',
                                                true,
                                            );
                                            fetchBusinessList(newValue);
                                            formik.setFieldValue(
                                                'orgCustomerId',
                                                null,
                                                true,
                                            );
                                            formik.setFieldError(
                                                'orgCustomerId',
                                                null,
                                            );
                                            formik.setTouched({
                                                orgCustomerId: false,
                                            });
                                            setSelectedOrgCustomer({});
                                            if (
                                                !Object.keys(defaultValue)
                                                    ?.length
                                            )
                                                fetchCityZones({
                                                    cityId: settings
                                                        ?.basicDetails
                                                        ?.operatingCityId,
                                                    hubIds: !!defaultValue?.id
                                                        ? [defaultValue?.id]
                                                        : null,
                                                    primaryOperation: !!newValue
                                                        ? newValue ===
                                                          HUB_TYPE_ENUM.STORE
                                                              .value
                                                            ? [
                                                                  HUB_TYPE_ENUM
                                                                      .FOOD
                                                                      .value,
                                                              ]
                                                            : [newValue]
                                                        : null,
                                                });
                                        }}
                                        size="medium"
                                        id="primaryOperation"
                                        name="primaryOperation"
                                        data-color={formik.values?.primaryOperation?.toLocaleLowerCase()}
                                        value={formik.values?.primaryOperation}
                                        style={{
                                            marginBottom: '16px',
                                            width: '48%',
                                        }}
                                        renderOption={(hub, { selected }) => {
                                            return (
                                                <MenuItem
                                                    value={
                                                        HUB_TYPE_ENUM[hub].value
                                                    }
                                                    style={{
                                                        color: HUB_TYPE_ENUM[
                                                            hub
                                                        ]?.color,
                                                        fontWeight: 'bold',
                                                        padding: 0,
                                                    }}
                                                >
                                                    {HUB_TYPE_ENUM[hub]?.label}
                                                </MenuItem>
                                            );
                                        }}
                                        renderInput={(params) => (
                                            <CustomTextField
                                                {...params}
                                                label="Business Type"
                                                id="primaryOperation"
                                                name="primaryOperation"
                                                data-color={formik.values?.primaryOperation?.toLocaleLowerCase()}
                                                error={
                                                    formik.touched
                                                        .primaryOperation
                                                        ? Boolean(
                                                              formik.errors
                                                                  .primaryOperation,
                                                          )
                                                        : false
                                                }
                                                helperText={
                                                    formik.touched
                                                        .primaryOperation &&
                                                    formik.errors
                                                        .primaryOperation
                                                }
                                                isRequired={true}
                                            />
                                        )}
                                    />
                                    {formik.values?.primaryOperation !==
                                        HUB_TYPE_ENUM.ECOM.value && (
                                        <Autocomplete
                                            multiple={false}
                                            options={orgCustomerMappings}
                                            getOptionLabel={(option) => {
                                                return option?.aliasName;
                                            }}
                                            onChange={(event, newValue) => {
                                                setSelectedOrgCustomer(
                                                    newValue,
                                                );
                                                formik.setFieldValue(
                                                    'orgCustomerId',
                                                    !!newValue?.id
                                                        ? Number(newValue?.id)
                                                        : null,
                                                    true,
                                                );
                                            }}
                                            size="medium"
                                            id="orgCustomerId"
                                            name="orgCustomerId"
                                            value={selectedOrgCustomer}
                                            style={{
                                                marginBottom: '16px',
                                                width: '48%',
                                            }}
                                            renderInput={(params) => (
                                                <CustomTextField
                                                    {...params}
                                                    label="Business Name"
                                                    id="orgCustomerId"
                                                    name="orgCustomerId"
                                                    error={
                                                        formik.touched
                                                            .orgCustomerId
                                                            ? Boolean(
                                                                  formik.errors
                                                                      .orgCustomerId,
                                                              )
                                                            : false
                                                    }
                                                    disableClearable={true}
                                                    helperText={
                                                        formik.touched
                                                            .orgCustomerId &&
                                                        formik.errors
                                                            .orgCustomerId
                                                    }
                                                    isRequired={true}
                                                />
                                            )}
                                        />
                                    )}

                                    <CustomTextField
                                        label="Zone"
                                        select
                                        style={{
                                            marginBottom: '16px',
                                            width: '48%',
                                        }}
                                        id="zoneId"
                                        name="zoneId"
                                        value={formik.values.zoneId}
                                        onChange={formik.handleChange}
                                        error={
                                            formik.touched.zoneId
                                                ? Boolean(formik.errors.zoneId)
                                                : false
                                        }
                                        helperText={
                                            formik.touched.zoneId &&
                                            formik.errors.zoneId
                                        }
                                        isRequired={
                                            [
                                                HUB_TYPE_ENUM.ECOM.value,
                                                HUB_TYPE_ENUM.FOOD.value,
                                            ].includes(
                                                formik.values?.primaryOperation,
                                            )
                                                ? true
                                                : false
                                        }
                                    >
                                        {zonesList.map((zone) => {
                                            return (
                                                <MenuItem value={zone.id}>
                                                    {zone.zoneName}
                                                </MenuItem>
                                            );
                                        })}
                                    </CustomTextField>
                                    <CustomTextField
                                        fullWidth={true}
                                        label="City"
                                        variant="outlined"
                                        style={{
                                            marginBottom: '16px',
                                            width: '48%',
                                        }}
                                        placeholder="City"
                                        inputProps={{
                                            readOnly: true,
                                        }}
                                        id="cityName"
                                        name="cityName"
                                        value={formik.values.cityName}
                                        onChange={formik.handleChange}
                                        error={
                                            formik.touched.cityName
                                                ? Boolean(
                                                      formik.errors.cityName,
                                                  )
                                                : false
                                        }
                                        helperText={
                                            formik.touched.cityName &&
                                            formik.errors.cityName
                                        }
                                        isRequired={true}
                                        disabled={true}
                                    />

                                    <CustomTextField
                                        fullWidth={true}
                                        label="State"
                                        variant="outlined"
                                        style={{
                                            marginBottom: '16px',
                                            width: '48%',
                                        }}
                                        placeholder="State"
                                        inputProps={{
                                            readOnly: true,
                                        }}
                                        id="stateName"
                                        name="stateName"
                                        value={formik.values.stateName}
                                        onChange={formik.handleChange}
                                        error={
                                            formik.touched.stateName
                                                ? Boolean(
                                                      formik.errors.stateName,
                                                  )
                                                : false
                                        }
                                        helperText={
                                            formik.touched.stateName &&
                                            formik.errors.stateName
                                        }
                                        isRequired={true}
                                        disabled={true}
                                    />
                                    {formik.values?.primaryOperation !==
                                        HUB_TYPE_ENUM.FOOD.value && (
                                        <>
                                            <div
                                                style={{
                                                    marginBottom: 16,
                                                    backgroundColor: '#eaedf3',
                                                    width: '100%',
                                                    height: 2,
                                                }}
                                            />
                                            <PlaceAutoComplete
                                                ref={placeAutoCompleteRef}
                                                label="Address"
                                                onChange={(val) => {
                                                    setAddress(val);
                                                    const state =
                                                        val.results[0]?.address_components.find(
                                                            (add) =>
                                                                add.types.includes(
                                                                    'administrative_area_level_1',
                                                                ),
                                                        );
                                                    const city =
                                                        val.results[0]?.address_components.find(
                                                            (add) =>
                                                                add.types.includes(
                                                                    'administrative_area_level_2',
                                                                ),
                                                        );
                                                    // formik.setFieldValue(
                                                    //     'stateName',
                                                    //     state?.long_name,
                                                    //     true,
                                                    // );
                                                    // formik.setFieldValue(
                                                    //     'cityName',
                                                    //     city?.long_name ??
                                                    //         state?.long_name,
                                                    //     true,
                                                    // );
                                                    setPosition(val.latLng);
                                                    formik.setFieldValue(
                                                        'address',
                                                        val.address,
                                                        true,
                                                    );
                                                    formik.setFieldValue(
                                                        'latitude',
                                                        val.latLng.lat,
                                                        true,
                                                    );
                                                    formik.setFieldValue(
                                                        'longitude',
                                                        val.latLng.lng,
                                                        true,
                                                    );
                                                }}
                                                isRequired={true}
                                                defaultValue={address}
                                                error={
                                                    formik.touched.address
                                                        ? Boolean(
                                                              formik.errors
                                                                  .address,
                                                          )
                                                        : false
                                                }
                                                helperText={
                                                    formik.touched.address &&
                                                    formik.errors.address
                                                }
                                            />
                                            {formik?.values
                                                ?.primaryOperation ===
                                                HUB_TYPE_ENUM.STORE.value && (
                                                <>
                                                    <CustomTextField
                                                        fullWidth={true}
                                                        label="latitude"
                                                        variant="outlined"
                                                        style={{
                                                            marginBottom:
                                                                '16px',
                                                            width: '48%',
                                                        }}
                                                        placeholder="latitude"
                                                        id="latitude"
                                                        name="latitude"
                                                        value={
                                                            formik.values
                                                                .latitude
                                                        }
                                                        inputProps={{
                                                            type: 'number',
                                                        }}
                                                        onChange={
                                                            formik.handleChange
                                                        }
                                                        error={
                                                            formik.touched
                                                                .latitude
                                                                ? Boolean(
                                                                      formik
                                                                          .errors
                                                                          .latitude,
                                                                  )
                                                                : false
                                                        }
                                                        helperText={
                                                            formik.touched
                                                                .latitude &&
                                                            formik.errors
                                                                .latitude
                                                        }
                                                        isRequired={true}
                                                    />
                                                    <CustomTextField
                                                        fullWidth={true}
                                                        label="longitude"
                                                        variant="outlined"
                                                        style={{
                                                            marginBottom:
                                                                '16px',
                                                            width: '48%',
                                                        }}
                                                        inputProps={{
                                                            type: 'number',
                                                        }}
                                                        placeholder="longitude"
                                                        id="longitude"
                                                        name="longitude"
                                                        value={
                                                            formik.values
                                                                .longitude
                                                        }
                                                        onChange={
                                                            formik.handleChange
                                                        }
                                                        error={
                                                            formik.touched
                                                                .longitude
                                                                ? Boolean(
                                                                      formik
                                                                          .errors
                                                                          .longitude,
                                                                  )
                                                                : false
                                                        }
                                                        helperText={
                                                            formik.touched
                                                                .longitude &&
                                                            formik.errors
                                                                .longitude
                                                        }
                                                        isRequired={true}
                                                    />
                                                </>
                                            )}
                                            {/* <div
                                                style={{
                                                    width: '100%',
                                                    display: 'flex',
                                                    flexDirection: 'row',
                                                    flexWrap: 'wrap',
                                                    alignItems: 'center',
                                                    justifyContent:
                                                        'space-between',
                                                }}
                                            >
                                                <Divider
                                                    style={{
                                                        marginBottom: '8px',
                                                        width: '45%',
                                                    }}
                                                />
                                                <Typography
                                                    variant="body2"
                                                    style={{
                                                        marginBottom: '8px',
                                                        width: '10%',
                                                        textAlign: 'center',
                                                    }}
                                                >
                                                    OR
                                                </Typography>
                                                <Divider
                                                    style={{
                                                        marginBottom: '8px',
                                                        width: '45%',
                                                    }}
                                                />
                                            </div> */}
                                            <CustomTextField
                                                fullWidth={true}
                                                label="Geofence Radius (m)"
                                                variant="outlined"
                                                inputProps={{
                                                    type: 'number',
                                                    min: 1,
                                                }}
                                                style={{ marginBottom: '16px' }}
                                                id="geofenceRadius"
                                                name="geofenceRadius"
                                                value={
                                                    formik.values.geofenceRadius
                                                }
                                                onChange={formik.handleChange}
                                                error={
                                                    formik.touched
                                                        .geofenceRadius
                                                        ? Boolean(
                                                              formik.errors
                                                                  .geofenceRadius,
                                                          )
                                                        : false
                                                }
                                                helperText={
                                                    formik.touched
                                                        .geofenceRadius &&
                                                    formik.errors.geofenceRadius
                                                }
                                                isRequired={true}
                                            />
                                        </>
                                    )}
                                    <Box
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'row',
                                            alignItems: 'center',
                                            justifyContent: 'space-between',
                                            marginBottom: '16px',
                                            marginTop: 10,
                                        }}
                                    >
                                        <Typography
                                            style={{
                                                display: 'flex',
                                                flexDirection: 'row',
                                                alignItems: 'center',
                                                color: '#14112d',
                                                marginRight: 10,
                                            }}
                                        >
                                            {`Slot Enabled Hub  `}
                                        </Typography>
                                        <CustomSwitch
                                            checked={
                                                formik?.values
                                                    ?.dedicatedSlotBookingEnabled
                                            }
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            error={
                                                formik.touched
                                                    .dedicatedSlotBookingEnabled &&
                                                Boolean(
                                                    formik.errors
                                                        .dedicatedSlotBookingEnabled,
                                                )
                                            }
                                            helperText={
                                                formik.touched
                                                    .dedicatedSlotBookingEnabled &&
                                                formik.errors
                                                    .dedicatedSlotBookingEnabled
                                            }
                                            name="dedicatedSlotBookingEnabled"
                                        />
                                    </Box>
                                    {formik.values?.primaryOperation === 'STORE' && (  
                                        <>  
                                            <Box  
                                                style={{  
                                                    display: 'flex',  
                                                    flexDirection: 'row',  
                                                    alignItems: 'center',  
                                                    justifyContent: 'space-between',  
                                                    marginBottom: '16px',  
                                                }}  
                                            >  
                                                <Typography  
                                                    style={{  
                                                        display: 'flex',  
                                                        flexDirection: 'row',  
                                                        alignItems: 'center',  
                                                        color: '#14112d',  
                                                        marginRight: 10,  
                                                    }}  
                                                >  
                                                    {`Referral Program  `}  
                                                </Typography>  
                                                <CustomSwitch  
                                                    checked={  
                                                        formik?.values?.referralProgram ?? false  
                                                    }  
                                                    onChange={(e) => {  
                                                        formik.setFieldValue(  
                                                            'referralProgram',  
                                                            e.target.checked,  
                                                        );  
                                                        if (!e.target.checked) {  
                                                            formik.setFieldValue(  
                                                                'referralAmount',  
                                                                null,  
                                                            );  
                                                        }  
                                                    }}  
                                                    name="referralProgram"  
                                                />  
                                            </Box>  
                                            {formik.values?.referralProgram && (  
                                                <CustomTextField  
                                                    fullWidth={true}  
                                                    label="Referral Amount (₹)"  
                                                    variant="outlined"  
                                                    inputProps={{  
                                                        type: 'number',  
                                                        min: 1,  
                                                    }}  
                                                    style={{ marginBottom: '16px' }}  
                                                    id="referralAmount"  
                                                    name="referralAmount"  
                                                    value={formik.values.referralAmount ?? ''}  
                                                    onChange={formik.handleChange}  
                                                    error={  
                                                        formik.touched.referralAmount  
                                                            ? Boolean(formik.errors.referralAmount)  
                                                            : false  
                                                    }  
                                                    helperText={  
                                                        formik.touched.referralAmount &&  
                                                        formik.errors.referralAmount  
                                                    }  
                                                    isRequired={true}  
                                                />  
                                            )}  
                                        </>  
                                    )}
                                    <div
                                        style={{
                                            position: 'absolute',
                                            bottom: 8,
                                            width: '45%',
                                        }}
                                    >
                                        <Divider style={{ marginTop: '0' }} />
                                        {!!actions && (
                                            <DialogActions>
                                                {actions.map(
                                                    (action, index) => (
                                                        <Box key={index}>
                                                            {action}
                                                        </Box>
                                                    ),
                                                )}
                                            </DialogActions>
                                        )}
                                    </div>
                                </DialogContent>
                            ) : (
                                <DialogContent>
                                    <CustomTextField
                                        fullWidth={true}
                                        label="Name"
                                        variant="outlined"
                                        style={{ marginBottom: '16px' }}
                                        id="name"
                                        name="name"
                                        value={formik.values.name}
                                        onChange={formik.handleChange}
                                        error={
                                            formik.touched.name
                                                ? Boolean(formik.errors.name)
                                                : false
                                        }
                                        helperText={
                                            formik.touched.name &&
                                            formik.errors.name
                                        }
                                    />
                                    <PlaceAutoComplete
                                        onChange={(val) => {
                                            setAddress(val);
                                            const state =
                                                val.results[0]?.address_components.find(
                                                    (add) =>
                                                        add.types.includes(
                                                            'administrative_area_level_1',
                                                        ),
                                                );
                                            const city =
                                                val.results[0]?.address_components.find(
                                                    (add) =>
                                                        add.types.includes(
                                                            'administrative_area_level_2',
                                                        ),
                                                );
                                            formik.setFieldValue(
                                                'stateName',
                                                state?.long_name,
                                                true,
                                            );
                                            formik.setFieldValue(
                                                'cityName',
                                                city?.long_name ??
                                                    state?.long_name,
                                                true,
                                            );
                                            setPosition(val.latLng);
                                            formik.setFieldValue(
                                                'address',
                                                val.address,
                                                true,
                                            );
                                        }}
                                        defaultValue={address}
                                    />
                                    {/* <CustomTextField
                                    label="City"
                                    select
                                    style={{ marginBottom: '16px' }}
                                    id="zoneId"
                                    name="zoneId"
                                    value={formik.values.zoneId}
                                    onChange={formik.handleChange}
                                    error={
                                        formik.touched.zoneId
                                            ? Boolean(formik.errors.zoneId)
                                            : false
                                    }
                                    helperText={
                                        formik.touched.zoneId &&
                                        formik.errors.zoneId
                                    }
                                >
                                    {cityList?.length === 0 && (
                                        <MenuItem value={undefined}>
                                            No Data found
                                        </MenuItem>
                                    )}
                                    {cityList?.map((city) => (
                                        <MenuItem value={city.id}>
                                            {city.name}
                                        </MenuItem>
                                    ))}
                                </CustomTextField> */}
                                    <CustomTextField
                                        fullWidth={true}
                                        label="City"
                                        variant="outlined"
                                        style={{ marginBottom: '16px' }}
                                        placeholder="City"
                                        inputProps={{
                                            readOnly: true,
                                        }}
                                        id="cityName"
                                        name="cityName"
                                        value={formik.values.cityName}
                                        onChange={formik.handleChange}
                                        error={
                                            formik.touched.cityName
                                                ? Boolean(
                                                      formik.errors.cityName,
                                                  )
                                                : false
                                        }
                                        helperText={
                                            formik.touched.cityName &&
                                            formik.errors.cityName
                                        }
                                    />
                                    <CustomTextField
                                        fullWidth={true}
                                        label="State"
                                        variant="outlined"
                                        style={{ marginBottom: '16px' }}
                                        placeholder="State"
                                        inputProps={{
                                            readOnly: true,
                                        }}
                                        id="stateName"
                                        name="stateName"
                                        value={formik.values.stateName}
                                        onChange={formik.handleChange}
                                        error={
                                            formik.touched.stateName
                                                ? Boolean(
                                                      formik.errors.stateName,
                                                  )
                                                : false
                                        }
                                        helperText={
                                            formik.touched.stateName &&
                                            formik.errors.stateName
                                        }
                                    />
                                    <Divider style={{ marginBottom: '15px' }} />
                                    <CustomTextField
                                        fullWidth={true}
                                        label="Geofence Radius (m)"
                                        variant="outlined"
                                        inputProps={{
                                            type: 'number',
                                            min: 1,
                                        }}
                                        style={{ marginBottom: '16px' }}
                                        id="geofenceRadius"
                                        name="geofenceRadius"
                                        value={formik.values.geofenceRadius}
                                        onChange={formik.handleChange}
                                        error={
                                            formik.touched.geofenceRadius
                                                ? Boolean(
                                                      formik.errors
                                                          .geofenceRadius,
                                                  )
                                                : false
                                        }
                                        helperText={
                                            formik.touched.geofenceRadius &&
                                            formik.errors.geofenceRadius
                                        }
                                    />
                                    <div
                                        style={{
                                            position: 'absolute',
                                            bottom: 8,
                                            width: '45%',
                                        }}
                                    >
                                        <Divider style={{ marginTop: '0' }} />
                                        {!!actions && (
                                            <DialogActions>
                                                {actions.map(
                                                    (action, index) => (
                                                        <Box key={index}>
                                                            {action}
                                                        </Box>
                                                    ),
                                                )}
                                            </DialogActions>
                                        )}
                                    </div>
                                </DialogContent>
                            )}
                        </Grid>
                        <Grid item xs={6}>
                            <Map
                                position={mapview}
                                bounds={getBounds()}
                                zoom={4}
                            >
                                {position && (
                                    <ChangeView
                                        position={position}
                                        markers={[position]}
                                    />
                                )}
                                {/* <MapEvents /> */}
                                {position && (
                                    <Marker
                                        draggable={true}
                                        eventHandlers={eventHandlers}
                                        icon={myIcon}
                                        ref={markerRef}
                                        position={position}
                                    >
                                        <Tooltip
                                            direction="top"
                                            offset={[-12, -60]}
                                            opacity={1}
                                        >
                                            you are here
                                        </Tooltip>
                                        {!!formik?.values?.geofenceRadius && (
                                            <Circle
                                                center={position}
                                                radius={
                                                    formik?.values
                                                        ?.geofenceRadius ?? 0
                                                }
                                                stroke={false}
                                                pathOptions={{
                                                    fillColor: 'blue',
                                                }}
                                            ></Circle>
                                        )}
                                    </Marker>
                                )}
                            </Map>
                        </Grid>
                    </Grid>
                </form>
            </Spinner>
        </Dialog>
    );
}

function ChangeView({ position, markers }) {
    const map = useMap();
    map.setView({ lng: position.lng, lat: position.lat }, 10);

    let markerBounds = L.latLngBounds([]);
    markers.forEach((marker) => {
        markerBounds.extend([marker.lat, marker.lng]);
    });
    markerBounds.isValid() && map.fitBounds(markerBounds);
    return null;
}

const mapStateToProps = (state) => ({
    settings: state.settings,
    statesList: state.settings?.statesList ?? [],
    cityList: state.settings?.cities ?? [],
    zonesList: state.settings?.zones ?? [],
    isEnabledXUtil: state?.user?.config?.isEnabledXUtil,
    orgCustomerMappings: state?.settings?.orgCustomerMappings,
    currentOrgId: state?.settings?.basicDetails?.id,
});

const mapDispatchToProps = (dispatch) => ({
    dispatchCreateHub: (payload, onSuccess, onError) =>
        dispatch(CreateHub(payload, onSuccess, onError)),
    dispatchEditHub: (payload, onSuccess, onError) =>
        dispatch(EditHub(payload, onSuccess, onError)),
    dispatchGetCities: (payload, onSuccess, onError) =>
        dispatch(GetCities(payload, onSuccess, onError)),
    dispatchGetCityZones: (payload, onSuccess, onError) =>
        dispatch(GetCityZones(payload, onSuccess, onError)),
    dispatchGetchZones: (payload, onSuccess, onError) =>
        dispatch(GetchZones(payload, onSuccess, onError)),
    dispatchGetBusinessList: (payload, filter, onSuccess, onError) =>
        dispatch(GetBusinessList(payload, filter, onSuccess, onError)),
});

const HubModalConnected = connect(
    mapStateToProps,
    mapDispatchToProps,
)(HubModal);

function HubModalWrapper(props) {
    return <HubModalConnected {...props} />;
}
export default HubModalWrapper;
